import React, { useEffect, useMemo, useRef, useState } from "react";

import useDeviceType from "../../hook/useDeviceType";
import i18next from "i18next";
import GAMEITEM from "../GAMEITEM/GAMEITEM";
import PROMOTIONITEM from "../GAMEITEM/PROMOTIONITEM";
import { languageTransfer } from "../../utils/languageTransfer";
import { useSelector } from "react-redux";
import LoaderGameList from "../Loading/LoadingGameList";

import { Splide, SplideSlide } from "@splidejs/react-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import { Grid } from "@splidejs/splide-extension-grid";
import { ErrorBoundary } from "react-error-boundary";
import { useInView } from "react-intersection-observer";

const SwiperGameList = React.forwardRef((props, ref) => {
  const {
    list = [], //遊戲list
    listType, //list類型
    itemClass, //item自定義class
    swiperProps, //放swiper的api
    isHot, //是否為熱門遊戲
    forceShow,
  } = props;

  const loadingStatus = useSelector((state) => state.isLoaderStatus);
  const { ref: containerRef, inView } = useInView({
    threshold: 0.75,
    rootMargin: "0px 0px 0px 0px",
  });

  useEffect(() => {
    if (listType === "promotion" || listType === "sponsor") {
      if (inView) {
        ref.current.splide.Components.AutoScroll.play();
      } else {
        ref.current.splide.Components.AutoScroll.pause();
      }
    }
  }, [inView]);

  const gamelist = useSelector((state) => state.isHandleAllGame); // 從Redux store取isHandleAllGame
  const {
    spaceBetween = 10,
    customPerView = "normal-layout",
    swiperClassName = "",
  } = swiperProps || {};

  const handleDrag = () => {
    const list = document.querySelector(".splide__list");
    list.classList.add("will-change-transform");
  };

  const handleDragged = () => {
    const list = document.querySelector(".splide__list");
    list.classList.remove("will-change-transform");
  };

  const customLayoutView = useMemo(() => {
    switch (customPerView) {
      case "normal-layout":
        return {
          xs: 3,
          md: 5,
          lg: 5,
          xl: 7,
        };
      case "new-game-layout":
        return {
          xs: 3,
          md: 5,
          lg: 5,
          xl: 6,
        };
      case "live-layout":
        return {
          xs: 1,
          md: 3,
          lg: 3,
          xl: 3,
        };
      case "promotion-layout":
        return {
          xs: 1,
          md: 2,
          lg: 3,
          xl: 3,
        };
      case "confirm-layout":
        return {
          xs: 3,
          md: 3,
          lg: 3,
          xl: 3,
        };
      case "game-box-layout":
        return {
          xs: 3,
          md: 5,
          lg: 5,
          xl: 8,
        };

      default:
        return {
          xs: 3,
          md: 5,
          lg: 5,
          xl: 7,
        };
    }
  }, [customPerView]);

  const renderedSlides = useMemo(() => {
    if (loadingStatus) {
      return Array.from({ length: 8 }, (_, i) => (
        <SplideSlide key={`loading-${i}`}>
          <LoaderGameList
            className={`${itemClass} lg:h-[185px] md:h-[160px] h-[130px]`}
          />
        </SplideSlide>
      ));
    }

    if (listType === "promotion") {
      return list.map((url, index) => (
        <SplideSlide key={`promotion-${index}`}>
          <PROMOTIONITEM
            itemClass={itemClass}
            url={url.image_mobile}
            originProps={url}
            index={index}
          />
        </SplideSlide>
      ));
    }
    return list?.map((item, index) => {
      const gameName =
        item?.[`gameName${languageTransfer({ lang: i18next.language })}`];
      const gameNameEn = item?.gameNameEn;
      const platform = item?.game_platform;
      const gameSubType = item?.game_subtype;
      const gameCode = item?.gameCode;
      const gameType = item?.gameType;

      return (
        <SplideSlide key={`${platform}-${gameNameEn}-${index}`}>
          <GAMEITEM
            gameProps={{
              gameName,
              platform,
              gameCode,
              gameType,
              gameNameEn,
              gameSubType,
            }}
            forceShow={forceShow}
            itemIndex={index}
            isHot={isHot}
            specMask={customPerView === "live-layout"}
            originProps={item}
            itemClass={itemClass}
          />
        </SplideSlide>
      );
    });
  }, [loadingStatus, listType, list, itemClass, customPerView]);
  return (
    <ErrorBoundary fallback={<div>&nbsp;</div>}>
      <div ref={containerRef}>
        <Splide
          ref={ref}
          onDrag={handleDrag}
          onDragged={handleDragged}
          className={` h-full w-full ${swiperClassName}`}
          {...(listType === "promotion" || listType === "sponsor"
            ? { extensions: { AutoScroll } }
            : {})}
          {...(customPerView === "live-layout" ? { extensions: { Grid } } : {})}
          options={{
            type: "slide",
            pagination: false,
            arrows: false,
            drag: "free",
            perPage: customLayoutView?.xl,
            perMove: 1,
            gap: spaceBetween,
            lazyLoad: "nearby",
            dragMinThreshold: {
              mouse: 0,
              touch: 10,
            },
            preloadPages: 1,
            keyboard: false,
            fixedWidth: customPerView === "live-layout" ? "26%" : false,
            breakpoints: {
              640: {
                perPage: customLayoutView?.xs,
                grid: {
                  dimensions: [[2, 2]],
                  gap: {
                    row: 10,
                    col: 10,
                  },
                },
                fixedWidth: false,
              },
              768: {
                perPage: customLayoutView?.md,
              },
              1024: {
                perPage: customLayoutView?.lg,
              },
              1280: {
                perPage: customLayoutView?.xl,
              },
            },
            // grid:
            //   customPerView === "live-layout"
            //     ? {
            //         rows: 2,
            //         cols: 1,
            //         gap: {
            //           row: "1rem",
            //           col: "1rem",
            //         },
            //       }
            //     : {},
          }}
        >
          {renderedSlides}
        </Splide>
      </div>
    </ErrorBoundary>
  );
});

export default React.memo(SwiperGameList);
